const TermsAndPrivacyPage = () => {
  return (
    <div className='container-fluid py-4 overflow-auto'>
      <h1>Terms of Service</h1>
      <p>
        <strong>1. Scope</strong>
        <br />
        These Terms of Service (ToS) apply to the use of the services provided by the web portal "AI Assistant" (hereinafter referred to as "Provider"). By registering and using the web portal, users accept these ToS.
      </p>
      <p>
        <strong>2. Subject of the Contract</strong>
        <br />
        The Provider offers AI assistants through the web portal. The use of these services is governed by the conditions outlined herein.
      </p>
      <p>
        <strong>3. Use of Services</strong>
        <br />
        The use of AI assistants is at the user's own risk. The Provider does not assume any liability for the accuracy, completeness, or timeliness of the information provided.
      </p>
      <p>
        <strong>4. Payment Terms</strong>
        <br />
        Fees for paid services are processed through the payment service provider Stripe. The user agrees to Stripe's payment terms.
      </p>
      <p>
        <strong>5. Liability</strong>
        <br />
        The Provider is liable only for intent and gross negligence. For damages caused by slight negligence, the Provider is only liable in the event of a breach of a fundamental contractual obligation.
      </p>
      <p>
        <strong>6. Data Protection</strong>
        <br />
        The Provider's Privacy Policy, which is an integral part of these ToS, applies.
      </p>
      <p>
        <strong>7. Final Provisions</strong>
        <br />
        The law of the Federal Republic of Germany applies. The place of jurisdiction is the Provider's registered office.
      </p>

      <h1>Privacy Policy</h1>
      <p>
        <strong>1. Responsible Entity</strong>
        <br />
        The entity responsible for data processing is: Company Name LLC, Example Street 123, 12345 Example City, Email: info@companyname.com.
      </p>
      <p>
        <strong>2. Collection and Processing of Personal Data</strong>
        <br />
        We collect personal data when you provide it to us as part of using our web portal or when registering. This includes, for example, name, email address, and payment information.
      </p>
      <p>
        <strong>3. Use of Data</strong>
        <br />
        The collected data is used exclusively for the provision and processing of services. Data will only be shared with third parties to the extent necessary for contract fulfillment or if we are legally obligated to do so.
      </p>
      <p>
        <strong>4. Storage and Deletion of Data</strong>
        <br />
        Your personal data is stored only as long as necessary to provide our services or as required by law. Data will be deleted after the retention periods expire.
      </p>
      <p>
        <strong>5. Your Rights</strong>
        <br />
        You have the right to request information about the data we hold about you, as well as to request its correction, deletion, or restriction of processing. Please contact us at: info@companyname.com.
      </p>
      <p>
        <strong>6. Changes to this Privacy Policy</strong>
        <br />
        We reserve the right to change this Privacy Policy at any time to reflect changes in the law or changes to our services or data processing practices.
      </p>
      <p>
        <strong>7. Contact</strong>
        <br />
        If you have any questions about data protection, please
        contact our data protection officer at: info@companyname.com.
  </p>
</div>
); };

export default TermsAndPrivacyPage;
